import { render, staticRenderFns } from "./OutboxTable.vue?vue&type=template&id=7803515e&"
import script from "./OutboxTable.vue?vue&type=script&lang=js&"
export * from "./OutboxTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports